import { render, staticRenderFns } from "./thirdHot.vue?vue&type=template&id=0a993b03&scoped=true&"
import script from "./thirdHot.vue?vue&type=script&lang=js&"
export * from "./thirdHot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a993b03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a993b03')) {
      api.createRecord('0a993b03', component.options)
    } else {
      api.reload('0a993b03', component.options)
    }
    module.hot.accept("./thirdHot.vue?vue&type=template&id=0a993b03&scoped=true&", function () {
      api.rerender('0a993b03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/child/thirdHot.vue"
export default component.exports